import { call, put, select } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { batchActions } from 'redux-batched-actions';
import { setLoadingJobsData, setJobsData, fetchJobsClient, getMzData, setFetchJobsFailed } from '../modules/JobsList';
import { setFacets, setMetadata, setFromQueryString, setSelectedFacets, setSort, setMaxDistance } from '../modules/Filters';
import { getCountry, getOptions } from '../modules/I18n';
import { setSearchDetails, setPlainUrl, setSavedSearches, setBase, getBase, getEmployerId, getSearchType, getInternationalUserProfile } from '../modules/Settings';
import { setAll as setSeo } from '../modules/Seo';
import queryString from 'query-string';
import _get from 'lodash/get';
import _assign from 'lodash/assign';
import transformToSavedJobs from '../lib/savedjobs-merge-transform';
import clientApi from '../lib/api-client';
import { generateAddToProfileData } from './generateAddToProfileData';

function* fetchSearchClient({ payload: { search, seokey } }) {
  try {
    yield put(setLoadingJobsData());
    const queryStringPart = search.substring(1).replace(/siteCountry=[^&#]*/, '');
    const QSObject = queryString.parse(queryStringPart);
    yield put(setFromQueryString(QSObject));
    const country = yield select(getCountry);
    const employerId = yield select(getEmployerId);
    const searchType = yield select(getSearchType);
    const isEmbed = searchType === 'embed';
    const isSupply = searchType === 'supply';

    let qs = [`siteCountry=${country}`];
    if (seokey) qs.push(`seokey=${seokey}`);
    if (queryStringPart !== '') qs.push(queryStringPart);
    if (employerId) qs.push('organisationId=' + employerId);
    if (isEmbed) qs.push('isEmbed=true');
    if (isSupply) qs.push('supplySearch=true');
    qs = qs.join('&');

    const { body: {
        searchResult,
        savedJobs,
        searchDetails,
        selectedFacets,
        savedSearches,
        baseQS
      }
    } = yield(call(clientApi, { qs }));
    const intUserProfile = yield select(getInternationalUserProfile);
    const { baseUrl, siteUrlPrefix } = yield select(getOptions);

    const base = yield select(getBase);
    const data = { ...searchResult, baseUrl, siteUrlPrefix };
    const url = base.pathname + baseQS ? `?${baseQS}` : '';
    data.jobs.items = transformToSavedJobs(data.jobs.items, savedJobs);
    if (isSupply) {
      data.SEOPageTitle = 'Supply teacher jobs | London, UK and International | Tes';
      data.SEOPageDescription = `Search and apply now for ${data.facets.count} supply teacher jobs in the UK and overseas with Tes Jobs. Find short-term and long-term supply work near you today.`;
    }

    const actions = [
      setPlainUrl(url),
      setSearchDetails(searchDetails),
      setSelectedFacets({ selectedFacets, facets: data.facets }),
      setSeo(data),
      setSort(_get(data, 'jobs.metadata.sort.selectedId', 'date')),
      setBase({ pathname: base.pathname.replace(seokey, ''), qs: baseQS ? `?${baseQS.replace(/&organisationId=[0-9]*/, '')}` : '' }),
      setMetadata(data.jobs.metadata),
      setFacets(data.facets),
      setSavedSearches(savedSearches),
      setJobsData(data),
    ];

    const distanceIndex = _get(data.facets, 'distance.maxDistance.currentValue.index');
    if (distanceIndex) actions.push(setMaxDistance(distanceIndex));

    yield put(batchActions(actions));

    yield call(generateAddToProfileData, { searchDetails: searchResult.searchDetails, intUserProfile });
    const mzData = yield select(getMzData);
    if (window._mz && window._mze) {
      window._mz.pageMetadata = _assign(mzData, { referrer: window._mz.pageMetadata ? window._mz.pageMetadata.referrer : {} });
      window._mz.emit(window._mze.PAGE_VIEW, { documentReferrer: document.referrer });
    }
  } catch (e) {
    console.error(e);
    yield put(setFetchJobsFailed());
  }
}

export function* watchFetchJobsClient() {
  yield takeLatest(fetchJobsClient, fetchSearchClient);
}
